import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "@unibuddy/intl";
import AccountLocked from "../../../PasswordReset/components/AccountLocked/AccountLocked";
import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_ACCOUNT_LOCKED, INTL_HERE} from "../../../../translations/accountLocked";

const requestPasswordLink = (t) => (
    <Link to="request">{t(INTL_HERE.key, INTL_HERE.defaultValue)}</Link>
);

const AccountLockedLayout = () => {
    const {t} = useTranslation(IntlNamespaces.ACCOUNT_LOCKED);
    return (
        <div>
            <PageTitle title={t(INTL_ACCOUNT_LOCKED.key, INTL_ACCOUNT_LOCKED.defaultValue)} />
            <AccountLocked requestResetPasswordLink={requestPasswordLink(t)} />
        </div>
    );
};

export default AccountLockedLayout;
